module.exports = __webpack_public_path__ + "img/clock.c8618982.jpg";